<!--
 @description: 预约使用
 @author: lsh
 @time: 2023-02-14 09:15:37
-->
<template>
    <div class="appointment-dialog-box">
      <el-dialog @close="closeDialog" class="appointment-dialog" :visible.sync="appointmentDialog" >
        <iframe
                :id=id
                width="576px" height="488px"
                frameborder="0"
                style="display: none; margin: 0 auto; height: 488px;border-radius: 18px;"
                :src=src
                scrolling="no"
                onload="this.style.display='block';"></iframe>
<!--        <div class="appointment-main">-->
          <!--                <div class="appointment-left" >-->
<!--                    <div class="title">现代化<br>智慧供应链体系</div>-->
<!--                    <div class="model-info">质量第一</div>-->
<!--                    <div class="model-info">效益优先</div>-->
<!--                    <div class="model-info">智慧决策</div>-->
<!--                    <div class="model-info">行业引领</div>-->
<!--                    <div class="model-phone"><img src="@/assets/image/navigationCommon/phonePopover.png">400-600-7966</div>-->
<!--                </div>-->
<!--                <div class="appointment-right" v-if="submissionSuccess == false" >-->
<!--                    <template>-->
<!--                        <div class="title">预约使用</div>-->
<!--                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0">-->
<!--                            <div class="form-label">单位名称<span style="color: red;">*</span></div>-->
<!--                            <el-form-item  prop="companyname">-->
<!--                                <el-select v-model="ruleForm.companyname"-->
<!--                                           style="width: 100%"-->
<!--                                           filterable remote reserve-keyword-->
<!--                                           placeholder="请输入您的单位名称"-->
<!--                                           :remote-method="queryCompanyName"-->
<!--                                           :loading="loading"-->
<!--                                           loading-text="加载中">-->
<!--                                    <el-option v-for="item in unitQuery" :key="item.id" :label="item.name" :value="item.name"></el-option>-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
<!--                            <div class="form-label">联系方式<span style="color: red;">*</span></div>-->
<!--                            <el-form-item prop="phone">-->
<!--                                <el-input placeholder="请输入您的联系方式" v-model="ruleForm.phone"></el-input>-->
<!--                            </el-form-item>-->
<!--                            <div class="form-label">验证码<span style="color: red;">*</span></div>-->
<!--                            <el-form-item prop="checkCode">-->
<!--                                <el-input placeholder="请输入验证码" v-model="ruleForm.checkCode">-->
<!--                                    <span @click="sendPhoneCodeMiddle" slot="suffix" class="verification-btn">{{ruleForm.messageCountdown}}</span>-->
<!--                                </el-input>-->
<!--                            </el-form-item>-->
<!--                            <el-form-item>-->
<!--                                <el-button class="appointment-btn" type="primary" @click="saveForm">预约使用</el-button>-->
<!--                            </el-form-item>-->
<!--                        </el-form>-->
<!--                    </template>-->
<!--                </div>-->
<!--                <div class="appointment-right appointment-okay" v-else>-->
<!--                    <img src="~@/assets/image/navigationCommon/markSuccess.png" />-->
<!--                    <div class="submit-successfully">提交成功</div>-->
<!--                    <div class="submit-text">我们会在3个工作日内与您联系，请注意接听来电</div>-->
<!--                    <el-button @click="appointmentDialog = false" class="okay">好的</el-button>-->
<!--                </div>-->
<!--        </div>-->
      </el-dialog>
    </div>
</template>

<script>
    import {queryCompanyName, saveForm, sendPhoneCode,} from '@/port/common/common';

    export default {
        name: "index",
        data(){
            return{
                appointmentDialog:false,
                submissionSuccess: false,
                loading: false,
                // ruleForm: {
                //     companyname: '',
                //     phone: '',
                //     checkCode: '',
                //     codeDisabled: false,
                //     messageCountdown: '发送验证码',
                // },
                // rules: {
                //     companyname: [
                //         {
                //             required: true,
                //             message: '请输入单位名称',
                //             trigger: 'blur',
                //         },
                //     ],
                //     phone: [
                //         {
                //             required: true,
                //             message: '请输入联系方式',
                //             trigger: 'blur',
                //         },
                //     ],
                //     checkCode: [
                //         {
                //             required: true,
                //             message: '请输入验证码',
                //             trigger: 'blur',
                //         },
                //     ],
                // },
                unitQuery:[],
                id:'',
                src:'',
            }
        },
      methods:{
            /*
            *  初始化
            * */
            init(data){
                this.id = data.id;
                this.src = data.src;
                this.appointmentDialog = true;
            },
            /*
            *  关闭弹框
            * */
            closeDialog(){
                // this.ruleForm = {
                //     companyname: '',
                //     phone: '',
                //     checkCode: '',
                //     codeDisabled: false,
                //     messageCountdown: '发送验证码',
                // };
                // this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
                // this.submissionSuccess = false;
                this.appointmentDialog = false;
            },
            /*
            * 预约使用名称查询
            * */
            // queryCompanyName(query) {
            //     this.loading = true;
            //     let storage = new FormData();
            //     storage.append('word', query);
            //     queryCompanyName(storage).then((response) => {
            //         if (response.data.result) {
            //             this.unitQuery = response.data.result.items;
            //         } else {
            //             this.unitQuery = [];
            //         }
            //         this.loading = false;
            //     });
            // },
            // sendPhoneCodeMiddle() {
            //     if (/(13|14|15||17|18|19)[0-9]{9}/.test(this.ruleForm.phone) == false) {
            //         this.$message.error('请输入正确的手机号!');
            //         return;
            //     }
            //     if (this.ruleForm.codeDisabled == true) return;
            //     this.ruleForm.codeDisabled = true;
            //     let countdown = 60;
            //     this.sendPhoneCode(this.ruleForm.phone);
            //     this.timerPopover = setInterval((_) => {
            //         if (countdown == 0) {
            //             this.ruleForm.codeDisabled = false;
            //             this.ruleForm.messageCountdown = '发送验证码';
            //             clearInterval(this.timerPopover);
            //             return;
            //         } else {
            //             countdown--;
            //             this.ruleForm.messageCountdown = `${countdown}S后重新发送`;
            //         }
            //     }, 1000);
            // },
            // sendPhoneCode(phoneNumber) {
            //     let storage = new FormData();
            //     storage.append('phoneNumber', phoneNumber);
            //     sendPhoneCode(storage).then((response) => {});
            // },
            /*
            *  提交
            * */
            // saveForm() {
            //     this.$refs.ruleForm.validate((valid) => {
            //         if (valid) {
            //             let storage = new FormData();
            //             storage.append('usename', '');
            //             storage.append('phone', this.ruleForm.phone);
            //             storage.append('companyname', this.ruleForm.companyname);
            //             storage.append('sourceway', '');
            //             storage.append('registerProduct', '全流程企业数字化采购平台');
            //             storage.append('job', '');
            //             storage.append('interestProduct', '全流程企业数字化采购平台');
            //             storage.append('concreteDemand', '全流程企业数字化采购平台');
            //             storage.append('checkCode', this.ruleForm.checkCode);
            //             saveForm(storage).then((response) => {
            //                 if (response.data == '注册成功') {
            //                     this.$message({
            //                         message: '注册成功!',
            //                         type: 'success',
            //                     });
            //                     this.submissionSuccess = true;
            //                 } else {
            //                     this.$message({
            //                         message: response.data + '!',
            //                         type: 'error',
            //                     });
            //                 }
            //             });
            //         }
            //     });
            // },
        }
    }

</script>

<style lang="scss" scoped>
    //.appointment-dialog{
        //.appointment-main{
        //  display: flex;
        //  flex-wrap: wrap;
            //.appointment-left{
            //    height: 100%;
            //    width: 320px;
            //    padding: 75px 58px 75px 38px;
            //    background:  url("~@/assets/image/dialog/dialog-bg.png") no-repeat center;
            //    .title{
            //        font-size: 28px;
            //        font-family: PingFang SC-Bold, PingFang SC;
            //        font-weight: bold;
            //        color: #FFFFFF;
            //        line-height: 40px;
            //        margin-bottom: 33px;
            //    }
            //    .model-info{
            //        display: flex;
            //        align-items: center;
            //        font-size: 18px;
            //        font-family: PingFang SC-Regular, PingFang SC;
            //        font-weight: 400;
            //        color: #FFFFFF;
            //        line-height: 36px;
            //        >img{
            //            margin-right: 9px;
            //        }
            //    }
            //    .model-phone{
            //        display: flex;
            //        align-items: center;
            //        font-size: 20px;
            //        font-family: PingFang SC-Regular, PingFang SC;
            //        font-weight: 400;
            //        color: #FFFFFF;
            //        margin-top: 43px;
            //        >img{
            //            margin-right: 9px;
            //        }
            //    }
            //}
            //.appointment-right{
            //    height: 100%;
            //    width: 470px;
            //    padding: 92px 70px;
            //    .title{
            //        text-align: center;
            //        font-size: 24px;
            //        font-family: PingFang SC-Bold, PingFang SC;
            //        font-weight: bold;
            //        color: #018DFF;
            //        line-height: 20px;
            //        margin-bottom: 33px;
            //    }
            //    .appointment-btn{
            //        width: 330px;
            //        height: 46px;
            //        margin-top: 30px;
            //        background:linear-gradient(90deg, #018DFF 0%, #1A74F1 100%) ;
            //    }
            //    .form-label{
            //        height: 27px;
            //        line-height: 27px;
            //    }
            //    .verification-btn{
            //        font-size: 14px;
            //        font-family: PingFang SC-Regular, PingFang SC;
            //        font-weight: 400;
            //        color: #186CF5;
            //        cursor: pointer;
            //    }
            //}
            //.appointment-okay{
            //    padding: 153px 62px;
            //    text-align: center;
            //    >img{
            //        margin-bottom: 38px;
            //    }
            //    .submit-successfully{
            //        font-size: 24px;
            //        font-family: PingFang SC-Bold, PingFang SC;
            //        font-weight: bold;
            //        color: #202124;
            //        margin-bottom: 7px;
            //    }
            //    .submit-text{
            //        font-size: 16px;
            //        font-family: PingFang SC-Regular, PingFang SC;
            //        font-weight: 400;
            //        color: #202124;
            //        margin-bottom: 80px;
            //    }
            //    .okay{
            //        height: 46px;
            //        width: 110px;
            //        color: #fff;
            //        background:linear-gradient(90deg, #018DFF 0%, #1A74F1 100%) ;
            //    }
            //}
        //}
    //}
    ::v-deep .el-dialog {
      width: 576px;
      border-radius: 20px;
      background: none;
      box-shadow: none;
    }
    ::v-deep .el-dialog__header {
        padding: 0;
        height: 0;
    }
    ::v-deep .el-dialog__body {
      padding: 0;
      display: flex;
      overflow:hidden ;
    }
    ::v-deep .el-input__inner {
      cursor: text;
    }

</style>
